import PropTypes from 'prop-types';

// material-ui
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

// constant
const headerStyle = {
  p: { xs: 1.5, sm: 2 },
  px: { xs: 1.5, sm: 2.5 },
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'flex-start', sm: 'center' },
  gap: { xs: 1.5, sm: 0 },
  '& .MuiCardHeader-content': {
    width: { xs: '100%', sm: 'auto' }
  },
  '& .MuiCardHeader-action': { 
    mr: 0,
    m: { xs: '0 !important', sm: 'auto' },
    width: { xs: '100%', sm: 'auto' },
    alignSelf: { xs: 'stretch', sm: 'center' }
  },
  '& .MuiCardHeader-title': {
    fontFamily: 'Poppins, sans-serif',
    fontSize: { xs: '14px', sm: '15px' },
    fontWeight: 500,
    color: 'text.primary'
  }
};

export default function MainCard({
  border = true,
  boxShadow,
  children,
  content = true,
  contentClass = '',
  contentSX = {},
  headerSX = {},
  darkTitle,
  secondary,
  shadow,
  sx = {},
  title,
  ref,
  ...others
}) {
  return (
    <Card
      ref={ref}
      {...others}
      sx={(theme) => ({
        bgcolor: theme.palette.mode === 'dark' ? 'background.paper' : '#FFFFFF',
        border: border ? (theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.06)' : '1px solid #E2E8F0') : 'none',
        borderRadius: '12px',
        boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 1px 3px rgba(0,0,0,0.03)',
        transition: 'all 0.2s ease-in-out',
        ':hover': {
          boxShadow: boxShadow
            ? shadow || (theme.palette.mode === 'dark' ? 'none' : '0 4px 16px rgba(0,0,0,0.06)')
            : (theme.palette.mode === 'dark' ? 'none' : '0 1px 3px rgba(0,0,0,0.03)')
        },
        ...(typeof sx === 'function' ? sx(theme) : sx || {})
      })}
    >
      {/* card header and action */}
      {!darkTitle && title && <CardHeader sx={{ ...headerStyle, ...headerSX }} title={title} action={secondary} />}
      {darkTitle && title && (
        <CardHeader
          sx={{ ...headerStyle, ...headerSX }}
          title={
            <Typography variant="h4" sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '15px', fontWeight: 500, color: 'text.primary' }}>
              {title}
            </Typography>
          }
          action={secondary}
        />
      )}

      {/* content & header divider */}
      {title && (
        <Divider
          sx={(theme) => ({
            borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#F1F5F9'
          })}
        />
      )}

      {/* card content */}
      {content && (
        <CardContent sx={contentSX} className={contentClass}>
          {children}
        </CardContent>
      )}
      {!content && children}
    </Card>
  );
}

MainCard.propTypes = {
  border: PropTypes.bool,
  boxShadow: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.bool,
  contentClass: PropTypes.string,
  contentSX: PropTypes.object,
  headerSX: PropTypes.object,
  darkTitle: PropTypes.bool,
  secondary: PropTypes.any,
  shadow: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  ref: PropTypes.object,
  others: PropTypes.any
};
